<template>
    <div class="content">
        <div class="header-container">
            <ul class="headLine">
                <li v-if="isLogin" class="avatar-container"><span class="avatar"></span><p>{{name}}</p></li>
                <li @click="navigateTo('login')" v-if="isLogin===false" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '登' : 'L'"></span><p v-text="language=='zh-CN' ? '录' : 'og In'"></p></li>
                <li @click="loginOut" v-if="isLogin" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '退' : 'L'"></span><p v-text="language=='zh-CN' ? '出' : 'og out'"></p></li>
                <li v-show="dailyEvent_ZH || dailyEvent_EN" @click="navigateToPDF" :class="language==='en-US' ? 'on' : ''"><span v-text="language=='zh-CN' ? '赛' : 'E'"></span><p v-text="language=='zh-CN' ? '事日程' : 'vent Schedule'"></p></li>
                <li :class="language==='en-US' ? 'on' : ''" @click="changeLanguage"><span v-text="language=='zh-CN' ? 'E' : 'C'"></span><p v-text="language=='zh-CN' ? 'N' : 'N'"></p></li>
            </ul>
            <div class="mainLogo">
                <img v-show="logoImg" @click="navigateTo('index')" class="logo" :src="logoImg">
                <div class="searchContent">
                    <div :class="language==='en-US' ? 'searchTool-container on' : 'searchTool-container'">
                        <!-- <div @click="voiceSearch" :class="language==='en-US' ? 'voice-container on' : 'voice-container'">
                            <img src="../assets/voiceIcon.png">
                            <p v-text="$t('m.voiceSearch')"></p>
                        </div>
                        <div @click="picSearch" :class="language==='en-US' ? 'pic-container on' : 'pic-container'">
                            <img src="../assets/picIcon.png">
                            <p v-text="$t('m.picSearch')"></p>
                        </div>
                        <div @click="faceSearch" :class="language==='en-US' ? 'face-container on' : 'face-container'">
                            <img src="../assets/faceIcon.png">
                            <p v-text="$t('m.faceSearch')"></p>
                        </div> -->
                    </div>
                    <div class="searchInput-container">
                        <input ref="searchInput" v-model="search" @focus="placeHolderWord='';isFocus=true;" @blur="setPlaceHolder()" :placeholder="placeHolderWord" @keyup.enter="searchKeyWord" type="text">
                        <div class="delIcon">
                            <img @click="delSearch" v-if="isFocus&&!isNull" src="../assets/del.png">
                        </div>
                        <div @click="searchKeyWord" class="search-container"></div>
                    </div>
                    <div class="hotWord-container">
                        <p v-text="$t('m.hotWord')"></p>
                        <ul>
                            <li @click="navigateToHotWord(item.en_title,item.zh_title)" v-for="item in indexList.hotwords"  v-text="language==='en-US' ? item.en_title : item.zh_title"></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="date-container">
                <ul>
                    <li v-for="(item,key) in indexList.date" @click='setIndex(key)' :class="key > saveIndex ? 'un' : index==key ? 'on' : ''">{{item.title}}</li>
                </ul>
            </div>
            <div class="dateTag-container">
                <ul>
                    <li v-for="item in sportType" @click="navigateToSearchList(item.key,item.zh_title,item.en_title)" :class="language==='en-US' ? 'on' : ''" v-text="language==='en-US' ? item.en_title : item.zh_title"></li>
                </ul>
            </div>
        </div>
        <div class="video-container">
            <div class="title">
                <div class="img-title">
                    <img :class="language==='zh-CN' ? 'videoTitleCnBig on' : 'videoTitleCnBig'" src="../assets/videoTitle.png">
                    <img :class="language==='zh-CN' ? 'videoTitleEnSmall on' : 'videoTitleEnSmall'" src="../assets/videoTitleEn.png">
                    <img :class="language==='en-US' ? 'videoTitleEnBig on' : 'videoTitleEnBig'" src="../assets/videoTitleEnBig.png">
                    <img :class="language==='en-US' ? 'videoTitleCnSmall on' : 'videoTitleCnSmall'" src="../assets/videoTitleSmall.png">
                </div>
                <div class="more">
                    <p @click="navigateTo('searchList')" v-text="$t('m.more')"></p>
                </div>
            </div>
            <ul class="videoList-container">
                <li @click="navigateToDetail(item.mediaId,item.category)" v-for="item in videoList">
                    <div class="img-container">
                        <img :src="item.cover">
                        <div class="timeInfo">
                            <img src="../assets/rightArrow.png">
                            <p>{{item.time}}</p>
                        </div>
                    </div>
                    <div class="info">
                        <p class="content">{{item.title}}</p>
                        <p class="size"><span v-text="$t('m.size')"></span>：{{item.size}}</p>
                        <p class="date">{{item.date}}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import bus from '../bus'
export default {
    data() {
        return {
            name: '',
            uid: '',
            unid: '',
            search: '',
            logoImg: '',
            sportType: [],
            videoList: [],
            indexList: {},
            dailyEvent_ZH: '',
            dailyEvent_EN: '',
            language: 'zh-CN',
            placeHolderWord: '所有',
            isLogin: false,
            isNull: true,
            isFocus: false,
            index: 0,
            saveIndex: 0
        }
    },
    watch: {
        language(to) {
            this.$i18n.locale = to;
            $.cookie('language',to);
        },
        index(to) {
            this.sportType = this.indexList.date[to].type;
        },
        search(to) {
            if(to.length>0){
                this.isNull = false;
                this.isFocus = true;
            }else{
                this.isNull = true;
            }
        }
    },
    methods: {
        delSearch() {
            this.search = '';
            // this.$refs.searchInput.focus();
            $('.searchInput-container input').focus();
            this.isFocus = true;
        },
        setPlaceHolder() {
            var that = this;
            if(this.search==''||this.search==null||this.search==undefined){
                if(this.language === 'zh-CN'){
                    this.placeHolderWord = '所有'
                }else{
                    this.placeHolderWord = 'All'
                }
            }
            setTimeout(function(){
                that.isFocus = false;
            },150)
        },
        getInfo() { //获取用户信息
            var that = this;
            require('../utils.js').requestWithToken({
                url: require('../config.json').urlBase + require('../config.json').url.user.info,
                success: function (res) {
                    if(res.code!='10000'){
                        localStorage.removeItem('uid');
                        localStorage.removeItem('unid');
                        localStorage.removeItem('name');
                        localStorage.removeItem('role');
                        that.isLogin = false;
                        that.role = '';
                    }
                },
                error: function () {
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'error',
                            message: '网络错误'
                        })
                    }else{
                        that.$message({
                            type: 'error',
                            message: 'Network Error'
                        })
                    }
                }
            })
        },
        setIndex(key) { //当前日期选择
            if(key<=this.saveIndex){
                this.index = key;
            }
        },
        navigateToHotWord(enTitle,zhTitle) { //跳转热词搜索
            bus.showAll = true;
            if(this.language==='zh-CN'){
                this.$router.push({
                    name: 'searchList',
                    params: {
                        keyWord: zhTitle
                    }
                })
            }else{
                this.$router.push({
                    name: 'searchList',
                    params: {
                        keyWord: enTitle
                    }
                })
            }
        },
        navigateToSearchList(name,cn,en) { //跳转视频列表页
            var that = this;
            // bus.sportNameCn = cn;
            // bus.sportNameEn = en;
            bus.showAll = true;
            this.$router.push({
                name: 'searchList',
                params: {
                    keyWord: null,
                    date: encodeURIComponent(that.indexList.date[that.index].key),
                    sport: encodeURIComponent(name)
                }
            })
        },
        searchKeyWord() { //关键词搜索
            var that = this;
            var keyWord = that.search;
            if(keyWord!=''&&keyWord!=null&&keyWord!=undefined){
                bus.showAll = true;
                this.$router.push({
                    name: 'searchList',
                    params: {
                        keyWord: encodeURIComponent(keyWord)
                    }
                })
            }else{
                bus.showAll = false;
                this.$router.push({
                    name: 'searchList',
                    params: {
                        keyWord: 'All'
                    }
                })
            }
        },
        getConfig() { //获取通用信息
            var that = this;
            require('../utils.js').requestWithToken({
                url: require('../config.json').urlBase + require('../config.json').url.user.getConfig,
                success: function(res) {
                    if(res.code==='10000'){
                        that.dailyEvent_ZH = res.result.dailyevents_url.zh_url;
                        that.dailyEvent_EN = res.result.dailyevents_url.en_url;
                        that.logoImg = res.result.logo;
                    }else{
                        if(that.language==='zh-CN'){
                            that.$message({
                                type: 'warning',
                                message: res.error.message.zh_msg
                            })
                        }else{
                            that.$message({
                                type: 'warning',
                                message: res.error.message.en_msg
                            })
                        }
                    }
                },
                error: function() {
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'error',
                            message: '网络错误'
                        })
                    }else{
                        that.$message({
                            type: 'error',
                            message: 'Network Error'
                        })
                    }
                }
            })
        },
        navigateToDetail(id,category) { //跳转视频详细内容页
            this.getInfo();
            if(category==1){
                if(this.isLogin){
                    this.$router.push({
                        name: 'videoDetail',
                        params: {
                            id: id
                        }
                    })
                }else{
                    if(this.language==='zh-CN'){
                        this.$message({
                            type: 'warning',
                            message: '请登录官方账号，获取更多视频操作权限。'
                        })
                    }else{
                        this.$message({
                            type: 'warning',
                            message: 'Please log in to the official account to get more video operation rights.'
                        })
                    }
                }
            }else{
                this.$router.push({
                    name: 'collectionVideo',
                    params: {
                        id: id
                    }
                })
            }
        },
        changeLanguage() { //修改当前语言
            var language = this.language;
            if(language==='zh-CN'){
                this.language = 'en-US'
                this.placeHolderWord = 'All'
            }else{
                this.language = 'zh-CN'
                this.placeHolderWord = '所有'
            }
        },
        getIndexList() { //获取首页内容
            var that = this;
            require('../utils.js').requestWithToken({
                url: require('../config.json').urlBase + require('../config.json').url.home.home,
                success: function(res) {
                    if(res.code==='10000'){
                        var date = new Date();
                        var year = date.getFullYear();
                        var month = date.getMonth()+1;
                        if(month<10){
                            month = '0'+month
                        }
                        var day = date.getDate();
                        if(day<10){
                            day = '0'+day
                        }
                        var nowDay = year+'-'+month+'-'+day;
                        var getDate = new Date(nowDay);
                        res.result.date.forEach(function(el,index){
                            var nowDate = new Date(el.key);
                            // 判断今日日期设定日期index
                            if(getDate>=nowDate){
                            //   console.log(999);
                            //   console.log(index)
                              that.index = index;
                              that.saveIndex = index;
                            }
                        })
                        res.result.list.data.forEach(function(el,index){
                            // 列表文字最多60字符截取
                            var regexp = /[^\x00-\xff]/g;// 正在表达式匹配中文
                            // var length = el.title.replace(regexp, "aa").length;
                            // if(length>=120){
                            //     // el.title = el.title.substring(0,60)+'...'
                            //     el.title = that.subString1(el.title,99)+'...';
                            // }
                            if(el.title.length > 60){
                                el.title = el.title.substring(0,60)+'...'
                            }
                        })
                        that.sportType = res.result.date[0].type;
                        that.videoList = res.result.list.data;
                        that.indexList = res.result;
                    }else{
                        if(that.language==='zh-CN'){
                            that.$message({
                                type: 'warning',
                                message: res.error.message.zh_msg
                            })
                        }else{
                            that.$message({
                                type: 'warning',
                                message: res.error.message.en_msg
                            })
                        }
                    }
                },
                error: function() {
                    if(that.language==='zh-CN'){
                        that.$message({
                            type: 'error',
                            message: '网络错误'
                        })
                    }else{
                        that.$message({
                            type: 'error',
                            message: 'Network Error'
                        })
                    }
                }
            })
        },
        navigateTo(res) { //跳转
            if(res==='login'){
              this.$router.push({
                  name: 'login',
                  params: {
                    sourceUrl: encodeURIComponent('index')
                  }
              })
            }else{
                if(res==='searchList'){
                    bus.showAll = false;
                }
              this.$router.push({
                  name: res
              })
            }
        },
        navigateToPDF() { //跳转PDF页面
            if(this.language==='zh-CN'){
                window.open(this.dailyEvent_ZH)
                // window.location.href = this.dailyEvent_ZH
            }else{
                window.open(this.dailyEvent_EN)
                // window.location.href = this.dailyEvent_EN
            }
        },
        voiceSearch() {
            bus.$emit('voiceSearch');
        },
        picSearch() {
            bus.$emit('picSearch');
        },
        faceSearch() {
            bus.$emit('faceSearch');
        },
        loginOut() { //退出登录
            var that = this;
            this.getInfo();
            var uid = localStorage.getItem('uid');
            var unid = localStorage.getItem('unid');
            var name = localStorage.getItem('name');
            var role = localStorage.getItem('role');
            if(uid!=''&&uid!=null&&uid!=undefined&&unid!=''&&unid!=null&&unid!=undefined){
                require('../utils.js').requestWithToken({
                    url: require('../config.json').urlBase + require('../config.json').url.user.loginout,
                    data: {
                        uid: this.uid,
                        unid: this.unid
                    },
                    success: function(res) {
                        if(res.code==='10000'){
                            that.isLogin = false;
                            that.name = '';
                            that.uid = '';
                            that.unid = '';
                            localStorage.removeItem('name');
                            localStorage.removeItem('uid');
                            localStorage.removeItem('unid');
                            localStorage.removeItem('role');
                            if(that.language==='zh-CN'){
                                that.$message({
                                    type: 'success',
                                    message: '退出成功'
                                })
                            }else{
                                that.$message({
                                    type: 'success',
                                    message: 'log out successfully'
                                })
                            }
                        }else{
                            if(that.language==='zh-CN'){
                                that.$message({
                                    type: 'warning',
                                    message: res.error.message.zh_msg
                                })
                            }else{
                                that.$message({
                                    type: 'warning',
                                    message: res.error.message.en_msg
                                })
                            }
                        }
                    },
                    error: function() {
                        if(that.language==='zh-CN'){
                            that.$message({
                                type: 'error',
                                message: '网络错误'
                            })
                        }else{
                            that.$message({
                                type: 'error',
                                message: 'Network Error'
                            })
                        }
                    }
                })
            }else{
                if(that.language==='zh-CN'){
                    that.$message({
                        type: 'success',
                        message: '退出成功'
                    })
                }else{
                    that.$message({
                        type: 'success',
                        message: 'log out successfully'
                    })
                }
            }
        },
        subString1(str, len){
            var regexp = /[^\x00-\xff]/g;// 正在表达式匹配中文
            // 当字符串字节长度小于指定的字节长度时
            if (str.replace(regexp, "aa").length <= len) {
                return str;
            }
            // 假设指定长度内都是中文
            var m = Math.floor(len/2);
            for (var i = m, j = str.length; i < j; i++) {
                // 当截取字符串字节长度满足指定的字节长度
                if (str.substring(0, i).replace(regexp, "aa").length >= len) {
                    return str.substring(0, i);
                }
            }
            return str;
        }
    },
    beforeDestroy() {

    },
    mounted() {
        setTimeout(function(){
            $('#app').css({
                "height": "auto"
            })
        })
        $('.content-container').css({
            "padding-bottom": "1rem",
            "background": "#e8ebf3"
        })
    },
    created() {
        var that = this;
        this.language = this.$i18n.locale;
        if(this.language === 'zh-CN'){
            this.placeHolderWord = '所有'
        }else{
            this.placeHolderWord = 'All'
        }
        this.getInfo();
        // 获取本地存储内用户信息
        var uid = localStorage.getItem('uid');
        var unid = localStorage.getItem('unid');
        var name = localStorage.getItem('name');
        if(uid!=''&&uid!=undefined&&uid!=null&&unid!=''&&unid!=undefined&&unid!=null&&name!=''&&name!=undefined&&name!=null){
            this.name = name;
            this.uid = uid;
            this.unid = unid;
            this.isLogin = true;
        }
        this.getIndexList();
        this.getConfig();
        bus.$on('search',function(e){
            that.search = e.search;
        })
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color:#B9B7B7;
    }

    input::-moz-placeholder{
        color:#B9B7B7;
    }

    input:-ms-input-placeholder{
        color:#B9B7B7;
    }

    .header-container {
        position: relative;
        width: 20.08rem;
        /* height: 12.87rem; */
        padding-bottom: 0.8rem;
        background: #FFF;
        box-sizing: border-box;
    }

    .header-container .mainLogo {
        width: 19.64rem;
        height: 10.20rem;
        background: url('../assets/indexBg.png') no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 0.65rem;
        user-select: none;
    }

    .header-container .mainLogo .logo {
        position: absolute;
        top: 0.99rem;
        left: 0.64rem;
        width: 6.4rem;
        height: 0.8rem;
        cursor: pointer;
    }

    .searchContent {
        position: absolute;
        top: 3.19rem;
        left: 2.14rem;
    }

    .header-container .searchTool-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 9.5rem;
        margin-left: 3.29rem;
        user-select: none;
    }

    .header-container .searchTool-container.on {
        /* width: 13.5rem; */
        /* margin-left: 1.58rem; */
        margin: 0px auto;
    }

    .header-container .searchTool-container > div {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
    }

    .header-container .searchTool-container > div.voice-container {
        min-width: 2rem;
        height: 0.48rem;
    }

    .header-container .searchTool-container > div.voice-container.on {
        min-width: 3rem;
    }

    .header-container .searchTool-container > div.voice-container img {
        width: 0.4rem;
        height: 0.48rem;
        margin-right: 0.16rem;
    }

    .header-container .searchTool-container > div.pic-container {
        min-width: 2.9rem;
        height: 0.48rem;
    }

    .header-container .searchTool-container > div.pic-container.on {
        min-width: 3.6rem;
    }

    .header-container .searchTool-container > div.pic-container img {
        width: 0.49rem;
        height: 0.47rem;
        margin-right: 0.16rem;
    }

    .header-container .searchTool-container > div.face-container {
        min-width: 2.8rem;
        height: 0.48rem;
    }

    .header-container .searchTool-container > div.face-container.on {
        min-width: 5rem;
    }

    .header-container .searchTool-container > div.face-container img {
        width: 0.42rem;
        height: 0.48rem;
        margin-right: 0.16rem;
    }

    .header-container .searchTool-container > div p {
        font-size: 0.32rem;
        color: #FFF;
    }

    .header-container .searchTool-container > div:hover p {
        font-size: 0.36rem;
        color: #FFF;
    }

    .header-container .searchInput-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 15.8rem;
        height: 1rem;
        background: #224bd2;
        border: 1px solid #224bd2;
        border-radius: 6px;
        box-sizing: border-box;
        margin: 0.5rem 0 0.32rem 0;
    }

    .header-container .searchInput-container input {
        width: 100%;
        height: 0.8rem;
        border: none;
        outline: none;
        padding: 0px 0 0 0.2rem;
        box-sizing: border-box;
        font-size: 0.36rem;
        color: #FFF;
    }

    .header-container .searchInput-container > .delIcon {
        position: relative;
        width: 0.32rem;
        height: 0.32rem;
        margin: 0 0.2rem 0 0.1rem;
        user-select: none;
        cursor: pointer;
    }

    .header-container .searchInput-container > .delIcon img {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 0.32rem;
        height: 0.32rem;
    }

    .header-container .searchInput-container input:focus + .search-container {
        width: 0.96rem;
        height: 0.8rem;
        border-left: 0.02rem solid #355ddf;
        background: url('../assets/searchIconOn.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        cursor: pointer;
        user-select: none;
    }

    .header-container .searchInput-container input:focus + .delIcon + .search-container {
        width: 0.96rem;
        height: 0.8rem;
        border-left: 0.02rem solid #355ddf;
        background: url('../assets/searchIconOn.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        cursor: pointer;
        user-select: none;
    }

    .header-container .searchInput-container .search-container {
        width: 0.96rem;
        height: 0.8rem;
        border-left: 0.02rem solid #355ddf;
        background: url('../assets/searchIcon.png') no-repeat;
        background-size: 0.46rem 0.46rem;
        background-position: center;
        cursor: pointer;
        user-select: none;
    }

    .header-container .hotWord-container {
        display: flex;
        flex-direction: row;
        font-size: 0.28rem;
        color: #eef3ff;
        /* margin: 0.36rem 0 0 1.5rem; */
        user-select: none;
    }

    .header-container .hotWord-container ul {
        display: flex;
        flex-direction: row;
    }

    .header-container .hotWord-container ul li {
        margin: 0 0.14rem 0.14rem 0;
        cursor: pointer;
    }

    .header-container .hotWord-container ul li:hover {
        cursor: pointer;
        color: #FFF;
    }

    .header-container .headLine {
        position: absolute;
        top: 0.16rem;
        right: 0.6rem;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        user-select: none;
    }

    .header-container .headLine li {
        position: relative;
        height: 0.36rem;
        z-index: 2;
        display: flex;
        flex-direction: row;
        align-items: baseline;
        font-size: 0.24rem;
        color: #10163e;
        text-align: center;
        cursor: pointer;
        margin-left: 0.5rem;
    }

    .header-container .headLine li.avatar-container {
        display: flex;
        align-items: center;
    }

    .header-container .headLine li span.avatar {
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 50%;
        background: #FFF;
        background: url('../assets/avatarIcon.png') no-repeat;
        background-size: 0.22rem 0.27rem;
        background-position: center;
        background-color: #FFF;
    }

    .header-container .headLine li::before {
        position: absolute;
        top: 50%;
        left: -0.05rem;
        z-index: -1;
        margin-top: -0.18rem;
        display: block;
        content: '';
        width: 0.36rem;
        height: 0.36rem;
        background: #FFF;
        border-radius: 50%;
    }

    .header-container .headLine li.on::before {
        position: absolute;
        top: 50%;
        left: -0.1rem;
        z-index: -1;
        margin-top: -0.18rem;
        display: block;
        content: '';
        width: 0.36rem;
        height: 0.36rem;
        background: #FFF;
        border-radius: 50%;
    }

    /* .header-container .headLine li:nth-of-type(1) {
        min-width: 0.64rem;
        height: 0.36rem;
    }

    .header-container .headLine li.on:nth-of-type(1) {
        min-width: 0.9rem;
        height: 0.36rem;
    }

    .header-container .headLine li:nth-of-type(2) {
        min-width: 1.2rem;
        height: 0.36rem;
        margin: 0 0.32rem 0 0.42rem;
    }

    .header-container .headLine li.on:nth-of-type(2) {
        min-width: 2rem;
        height: 0.36rem;
        margin: 0 0.32rem 0 0.42rem;
    }

    .header-container .headLine li:nth-of-type(3) {
        min-width: 0.84rem;
        height: 0.36rem;
    } */

    .header-container .headLine li:hover {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 0.28rem;
        color: #1e69fe;
        text-align: center;
        cursor: pointer;
    }

    .header-container .headLine li span {
        display: inline-block;
        /* width: 0.36rem;
        height: 0.36rem; */
        line-height: 0.36rem;
        font-size: 0.28rem;
        color: #1e69fe;
        /* border-radius: 50%; */
        /* background: #FFF; */
    }

    .header-container .headLine li p {
        line-height: 0.36rem;
    }

    .header-container .headLine li:nth-last-of-type(1)::after {
        display: block;
        content: '';
        width: 0.09rem;
        height: 0.13rem;
        margin-left: 0.07rem;
        background: url('../assets/leftArrow.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .header-container .headLine li:nth-last-of-type(1):hover::after {
        display: block;
        content: '';
        width: 0.09rem;
        height: 0.13rem;
        margin-left: 0.07rem;
        background: url('../assets/leftArrowOn.png') no-repeat;
        background-size: 100%;
        background-position: center;
    }

    .header-container .date-container {
        position: absolute;
        top: 8.16rem;
        left: 2.14rem;
        width: 15.8rem;
        user-select: none;
    }

    .header-container .date-container ul {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        width: 15.8rem;
        font-size: 0.28rem;
        color: #10163e;
    }

    .header-container .date-container ul li {
        height: 0.32rem;
        cursor: pointer;
        text-align: center;
    }

    .header-container .date-container ul li.un {
        font-size: 0.28rem;
        color: #848a9d;
    }

    .header-container .date-container ul li.on {
        position: relative;
        font-size: 0.36rem;
        line-height: 0.36rem;
        color: #1e69fe;
    }

    .header-container .date-container ul li.on::after {
        position: absolute;
        bottom: -0.32rem;
        left: 50%;
        display: block;
        content: '';
        width: 0.4rem;
        height: 0.12rem;
        border-radius: 20px;
        background: #1e69fe;
        margin-left: -0.2rem;
    }

    .header-container .dateTag-container {
        display: flex;
        justify-content: center;
        margin-top: -1.1rem;
        /* position: absolute;
        top: 9.07rem;
        left: 2.14rem; */
        /* margin: 0px auto; */
    }

    .header-container .dateTag-container ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        width: 15.8rem;
    }

    .header-container .dateTag-container ul li {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        min-width: 2.3rem;
        height: 0.8rem;
        font-size: 0.28rem;
        color: #1e69fe;
        border: 0.14rem solid #e0e7ff;
        border-radius: 40px;
        padding: 0 0.1rem;
        box-sizing: border-box;
        margin: 0 0.4rem 0.2rem 0;
        cursor: pointer;
        font-weight: bold;
        user-select: none;
    }

    .header-container .dateTag-container ul li:hover {
        color: #10163e;
    }

    .header-container .dateTag-container ul li.on {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        min-width: 3.88rem;
        height: 0.8rem;
        font-size: 0.28rem;
        color: #1e69fe;
        border: 0.14rem solid #e0e7ff;
        border-radius: 40px;
        padding: 0 0.1rem;
        box-sizing: border-box;
        margin: 0 0.06rem 0.2rem 0;
        cursor: pointer;
        font-weight: bold;
    }

    .header-container .dateTag-container ul li.on:hover {
        color: #10163e;
    }

    .header-container .dateTag-container ul li.on:nth-of-type(4n+0) {
        margin-right: 0px;
    }

    .header-container .dateTag-container ul li.on:nth-of-type(6n+0) {
        margin-right: 0.06rem;
    }

    .header-container .dateTag-container ul li:nth-of-type(6n+0) {
        margin-right: 0px;
    }

    .video-container .title {
        overflow: hidden;
        margin-bottom: 0.5rem;
    }

    .video-container .title .img-title {
        float: left;
        margin: 0.6rem 0 0 0.64rem;
        user-select: none;
    }

    .video-container .title .img-title img {
        display: none;
    }

    .video-container .title .img-title img.videoTitleCnBig {
        width: 1.6rem;
        height: 0.37rem;
        margin-bottom: 0.1rem;
    }

    .video-container .title .img-title img.videoTitleEnSmall {
        width: 0.77rem;
        height: 0.18rem;
    }

    .video-container .title .img-title img.videoTitleEnBig {
        width: 1.93rem;
        height: 0.43rem;
        margin-bottom: 0.1rem;
    }

    .video-container .title .img-title img.videoTitleCnSmall {
        width: 0.84rem;
        height: 0.20rem;
    }

    .video-container .title .img-title img.on {
        display: block;
    }

    .video-container .title .more {
        float: right;
        font-size: 0.24rem;
        color: #1e69fe;
        margin: 0.82rem 0.6rem 0 0;
        cursor: pointer;
        user-select: none;
    }

    .video-container .title .more:hover {
        float: right;
        font-size: 0.24rem;
        color: #10163e;
        margin: 0.82rem 0.6rem 0 0;
        cursor: pointer;
    }

    .video-container .videoList-container {
        padding-left: 0.64rem;
        box-sizing: border-box;
        overflow: hidden;
    }

    .video-container .videoList-container li {
        float: left;
        width: 6rem;
        height: 6.6rem;
        background: #FFF;
        border-radius: 6px;
        box-sizing: border-box;
        margin: 0 0.42rem 1rem 0;
        overflow: hidden;
        cursor: pointer;
    }

    .video-container .videoList-container li:nth-of-type(3n+0) {
        margin-right: 0px;
    }

    .video-container .videoList-container li .img-container {
        position: relative;
        width: 6rem;
        height: 3.38rem;
    }

    .video-container .videoList-container li .img-container .timeInfo {
        position: absolute;
        bottom: -0.38rem;
        right: 0.24rem;
        overflow: hidden;
        user-select: none;
    }

    .video-container .videoList-container li .img-container .timeInfo img {
        display: inline-block;
        vertical-align: middle;
        width: 0.24rem;
        height: 0.3rem;
    }

    .video-container .videoList-container li .img-container .timeInfo p {
        display: inline-block;
        vertical-align: middle;
        font-size: 0.24rem;
        color: #FFF;
    }

    .video-container .videoList-container li .img-container img {
        width: 6rem;
        height: 3.38rem;
        user-select: none;
    }

    .video-container .videoList-container li .info .content {
        height: 1.6rem;
        padding: 0 0.2rem;
        font-size: 0.32rem;
        line-height: 0.56rem;
        color: #10163e;
        box-sizing: border-box;
        margin-top: 0.2rem;
        word-break: break-all;
        user-select: none;
    }

    .video-container .videoList-container li .info .size {
        font-size: 0.24rem;
        color: #848a9d;
        padding: 0px 0.2rem;
        box-sizing: border-box;
        margin: 0.3rem 0 0.1rem 0;
        user-select: none;
    }

    .video-container .videoList-container li .info .date {
        font-size: 0.24rem;
        color: #848a9d;
        padding: 0px 0.2rem;
        box-sizing: border-box;
        user-select: none;
    }

</style>
